const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim())
}

export interface UserRoleAssignment {
  role: string
  traderId?: number | null
}

export interface UserSchema {
  id?: number
  email: string
  firstName: string
  middleName: string | null
  lastName: string
  phoneNumber: string | null
  jobTitle: string
  roles: UserRoleAssignment[]
}

export const EMPTY_USER: UserSchema = {
  id: 0,
  email: '',
  firstName: '',
  middleName: '',
  lastName: '',
  phoneNumber: null,
  jobTitle: '',
  roles: []
}

export type UserFieldErrors = Partial<Record<'email' | 'firstName' | 'lastName' | 'jobTitle', string>>

export type UserFormErrors = UserFieldErrors & { roles?: string; root?: string }

export function validateUser(values: UserSchema): UserFieldErrors {
  const errors: UserFieldErrors = {}
  if (!isValidEmail(values.email)) errors.email = 'Invalid email address'
  if (!values.firstName.trim()) errors.firstName = 'First Name is required'
  if (!values.lastName.trim()) errors.lastName = 'Last Name is required'
  if (!values.jobTitle.trim()) errors.jobTitle = 'Job Title is required'
  return errors
}

export interface LoginSchema {
  username: string
  password: string
}

export type LoginFieldErrors = Partial<Record<'username' | 'password', string>>

export function validateLogin(values: LoginSchema): LoginFieldErrors {
  const errors: LoginFieldErrors = {}
  if (!isValidEmail(values.username)) errors.username = 'Invalid email address'
  if (!values.password) errors.password = 'Password is required'
  return errors
}

export interface ResetPasswordSchema {
  email: string
}

export type ResetPasswordFieldErrors = Partial<Record<'email', string>>

export function validateResetPassword(values: ResetPasswordSchema): ResetPasswordFieldErrors {
  const errors: ResetPasswordFieldErrors = {}
  if (!isValidEmail(values.email)) errors.email = 'Invalid email address'
  return errors
}

export interface ChangePasswordSchema {
  token?: string
  newPassword: string
  confirmPassword: string
}

export type ChangePasswordFieldErrors = Partial<Record<'newPassword' | 'confirmPassword', string>>

export function validateChangePassword(values: ChangePasswordSchema): ChangePasswordFieldErrors {
  const errors: ChangePasswordFieldErrors = {}
  if (values.newPassword.length < 8) errors.newPassword = 'Password must be at least 8 characters'
  if (values.confirmPassword.length < 8) {
    errors.confirmPassword = 'Password must be at least 8 characters'
  } else if (values.newPassword !== values.confirmPassword) {
    errors.confirmPassword = "Passwords don't match"
  }
  return errors
}
